export default __webpack_public_path__ + "static/media/9.5fff45bd.jpg";